var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpandIconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#expandIconSvg_svg__clip0_1016_3702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.607.001l7.366 7.751L16.449.173 18 1.823 8.916 11 0 1.596 1.607.001z",
    fill: "#E0621E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "expandIconSvg_svg__clip0_1016_3702"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(1 0 0 -1 0 11)",
    d: "M0 0h18v11H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxOCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwMTZfMzcwMikiPgo8cGF0aCBkPSJNMS42MDcxNCAwLjAwMTMxMzY5TDguOTcyOTcgNy43NTIyMkwxNi40NDk0IDAuMTczMTg3TDE4IDEuODIzMkw4LjkxNjQzIDExTDEuMzk0NDNlLTA3IDEuNTk2MzZMMS42MDcxNCAwLjAwMTMxMzY5WiIgZmlsbD0iI0UwNjIxRSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEwMTZfMzcwMiI+CjxyZWN0IHdpZHRoPSIxOCIgaGVpZ2h0PSIxMSIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIDAgMTEpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgExpandIconSvg as ReactComponent };